module.exports = __webpack_public_path__ + "static/media/undraw_certificate_343v.36c1403d.svg";